
import { Injectable } from '@angular/core';
@Injectable()
export class ConfigProd {
  
    public ENDPOINT_API: string = 'WSprecheck/';
}